import { configureStore } from '@reduxjs/toolkit';
import counterReducer from './slices/counter/counterSlice';
import cartReducer from './slices/cartSlice';
import ebookAccessReducer from './slices/ebookAccessSlice';
import secureEbookStorageReducer from './slices/secureEbookStorageSlice';
import ebookDownloadReducer from './slices/ebookDownloadSlice';
import authReducer from './slices/authSlice';
import cartMiddleware from './middleware/cartMiddleware';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    cart: cartReducer,
    ebookAccess: ebookAccessReducer,
    secureEbookStorage: secureEbookStorageReducer,
    ebookDownload: ebookDownloadReducer,
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(cartMiddleware),
});
